import React, { useRef, useEffect } from "react";
import PropTypes from "prop-types";
import omit from "lodash/omit";

export default function ResizableContainer(props) {
    const containerRef = useRef();

    useEffect(() => {
        if (containerRef.current) {
            const ro = new ResizeObserver((entries) => {
                const { width, height } = entries[0].contentRect;
                props.onResize({
                    width,
                    height,
                });
            });
            ro.observe(containerRef.current);
            return () => {
                if (!!containerRef.current) {
                    ro.unobserve(containerRef.current);
                }
            };
        }
    }, [containerRef]);

    return (
        <div
            {...omit(props, ["onResize"])}
            ref={containerRef}
            className={props.className}
        >
            {props.children}
        </div>
    );
}

ResizableContainer.propTypes = {
    onResize: PropTypes.func.isRequired,
};
